/* ================================================================
   EF GAS LOGS CONFIGURATOR — LOGIC
   ================================================================ */

/* ── Accordion toggle (doors-style) ──
   DEFINED FIRST, before the main IIFE, on purpose: the template calls it via
   inline `onclick="efgAccToggle(this)"`. If anything below throws synchronously
   the rest of this file stops executing — so defining the accordion handler
   here guarantees it always exists at click time (was previously at the very
   bottom and never reached → "efgAccToggle is not defined"). */
window.efgAccToggle = function(trigger) {
  var item = trigger.closest('.ef-cfg-gas-acc-item');
  if (!item) return;
  var body = item.querySelector('.ef-cfg-gas-acc-body');
  var isOpen = item.classList.contains('is-open');

  /* Close all other items. Opening is driven by the `.is-open` class
     (see ef-pdp-gas-logs.css) so it survives the !important cascade; the
     inline max-height is set with `important` priority as an exact-height
     refinement / belt-and-suspenders. */
  document.querySelectorAll('.ef-cfg-gas-acc-item.is-open').forEach(function(other) {
    if (other !== item) {
      other.classList.remove('is-open');
      var ot = other.querySelector('.ef-cfg-gas-acc-trigger');
      if (ot) ot.setAttribute('aria-expanded', 'false');
      var ob = other.querySelector('.ef-cfg-gas-acc-body');
      if (ob) ob.style.setProperty('max-height', '0', 'important');
    }
  });

  if (isOpen) {
    item.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    if (body) body.style.setProperty('max-height', '0', 'important');
  } else {
    item.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    if (body) body.style.setProperty('max-height', body.scrollHeight + 'px', 'important');
  }
};

(function() {
  'use strict';

  /* ── Data (from AVIS option-set "Gas Logs - Formation Creation") ── */
  var AVIS_IMG = 'https://product-options-img.avisplus.io/dea3576e-57ee-4c55-9762-cd856a5bf704/';
  var DATA = {
    fuelTypes: [
      { label: 'Natural Gas',       surcharge: 0,   variantId: null },
      { label: 'Propane',           surcharge: 368, variantId: '42278546145362' }
    ],
    /* Ignition options — surcharges = original Avis variant prices ($225/$410/$520).
       Earlier attempt to derive from GCGL pricebook pages 6-7 was incorrect per
       user feedback (those are factory-assembled BUNDLE prices, not standalone
       ignition surcharges). Variant IDs map to specific Shopify SKUs whose prices
       are the source of truth for cart math. 2026-05-06 v4.
       Names include "and Remote System" suffix so buyer knows which packages
       ship with a wireless remote (per manufacturer GCGL naming convention). */
    ignitionByFuel: {
      'Natural Gas': [
        { name: 'Match Lit',                              desc: 'Light manually with a long match. No controls included.',                       surcharge: 0,   variantId: null,             img: AVIS_IMG + 'hand_ignites_vented_gas_fireplace_with_lighter_1770190706484x300.png' },
        { name: 'Manual Safety Pilot',                    desc: 'Manual on/off with safety pilot light. No remote.',                             surcharge: 225, variantId: '42278546210898', img: AVIS_IMG + 'blue_pilot_light_fireplace_gas_valve_assembly_1770190716662x300.png' },
        { name: 'Millivolt and Remote System',            desc: 'Wall switch + wireless remote. Includes remote system.',                        surcharge: 410, variantId: '42278546243666', img: AVIS_IMG + 'fireplace_switch_lighting_warm_ceramic_logs_glow_1770190934024x300.png' },
        { name: 'Battery Electronic and Remote System',   desc: 'Battery-powered electronic ignition with wireless remote. Includes remote system.', surcharge: 520, variantId: '42278546276434', img: AVIS_IMG + 'modern_gas_fireplace_with_remote_control__1770191193022x300.png' }
      ],
      'Propane': [
        { name: 'Manual Safety Pilot',                    desc: 'Manual on/off with safety pilot light. No remote.',                             surcharge: 225, variantId: '42278546341970', img: AVIS_IMG + 'blue_pilot_light_fireplace_gas_valve_assembly_1770190716662x300.png' },
        { name: 'Millivolt and Remote System',            desc: 'Wall switch + wireless remote. Includes remote system.',                        surcharge: 410, variantId: '42278546374738', img: AVIS_IMG + 'fireplace_switch_lighting_warm_ceramic_logs_glow_1770190934024x300.png' },
        { name: 'Battery Electronic and Remote System',   desc: 'Battery-powered electronic ignition with wireless remote. Includes remote system.', surcharge: 520, variantId: '42278546407506', img: AVIS_IMG + 'modern_gas_fireplace_with_remote_control__1770191193022x300.png' }
      ]
    }
  };

  /* ── State ── */
  var TOTAL_STEPS = 3;
  var state = {
    step: 1,
    fuelType: DATA.fuelTypes[0],   /* default: Natural Gas */
    ignition: DATA.ignitionByFuel['Natural Gas'][0]   /* default: Match Lit */
  };

  /* ── DOM refs ── */
  var $wrap       = document.getElementById('efgWrap');
  var $stepCur    = document.getElementById('efgStepCur');
  var $fill       = document.getElementById('efgFill');
  var $barFill    = document.getElementById('efgBarFill');

  /* ── Helpers ── */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function fmt(n) { return n === 0 ? 'Included' : '+$' + n.toLocaleString('en-US'); }

  function calcTotal() {
    var t = 0;
    if (state.fuelType) t += state.fuelType.surcharge;
    if (state.ignition) t += state.ignition.surcharge;
    return t;
  }

  function updateTotal() {
    var surcharge = calcTotal();
    var basePrice = (window.EF_GAS_LOGS_DATA.basePrice / 100);
    var total = basePrice + surcharge;

    /* Update price box — Base Price line */
    var basePriceEl = document.getElementById('efgBasePrice');
    if (basePriceEl) basePriceEl.textContent = '$' + basePrice.toLocaleString('en-US', {minimumFractionDigits:2});

    /* Update surcharge lines */
    var linesEl = document.getElementById('efgSurchargeLines');
    if (linesEl) {
      linesEl.innerHTML = '';
      if (state.fuelType && state.fuelType.surcharge > 0)
        addLine(linesEl, '+ Fuel (' + state.fuelType.label + ')', '+$' + state.fuelType.surcharge.toLocaleString());
      if (state.ignition && state.ignition.surcharge > 0)
        addLine(linesEl, '+ Ignition (' + state.ignition.name + ')', '+$' + state.ignition.surcharge.toLocaleString());
    }

    /* Update Total */
    var totalEl = document.getElementById('efgTotalPrice');
    if (totalEl) totalEl.textContent = '$' + total.toLocaleString('en-US', {minimumFractionDigits:2});

    /* Header price stays at base "From" — don't overwrite (matches doors UX) */

    /* Update Add to Cart button */
    var submitBtn = document.getElementById('efgSubmit');
    if (submitBtn && !submitBtn.disabled) submitBtn.textContent = 'Add to Cart \u2014 $' + total.toLocaleString('en-US', {minimumFractionDigits:2});
  }

  function addLine(container, label, value) {
    var div = document.createElement('div');
    div.style.cssText = 'display:flex;justify-content:space-between;align-items:baseline;gap:12px;padding:4px 0;font-family:Inter,sans-serif;font-size:13px;color:#5C5852;max-width:100%;';
    div.innerHTML = '<span style="flex:1 1 auto;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' + label + '</span><span style="color:#8A6A43;font-weight:500;flex-shrink:0;white-space:nowrap;">' + value + '</span>';
    container.appendChild(div);
  }

  /* ── Progress ── */
  function updateProgress() {
    var nodes = $$('.ef-cfg-gas-progress__node');
    var cur = state.step;
    /* Progress bar was removed from the template (configurator flattened to a
       single page), so #efgStepCur no longer exists. Guard against null —
       previously this threw synchronously and halted the whole script. */
    if ($stepCur) $stepCur.textContent = cur;

    nodes.forEach(function(node) {
      var s = parseInt(node.getAttribute('data-step'));
      node.classList.remove('is-active', 'is-done');
      if (s < cur) node.classList.add('is-done');
      else if (s === cur) node.classList.add('is-active');
    });

    /* Track fill */
    var pct = TOTAL_STEPS > 1 ? ((cur - 1) / (TOTAL_STEPS - 1)) * 100 : 0;
    if ($fill) $fill.style.width = pct + '%';
    if ($barFill) $barFill.style.width = (cur / TOTAL_STEPS * 100) + '%';
  }

  /* ── Navigation ── */
  function goToStep(n) {
    if (n < 1 || n > TOTAL_STEPS) return;
    state.step = n;
    $$('.ef-cfg-gas-step').forEach(function(el) { el.classList.remove('is-visible'); });
    var target = document.querySelector('.ef-cfg-gas-step[data-step="' + n + '"]');
    if (target) target.classList.add('is-visible');

    updateProgress();
    updateTotal();

    /* Build review on final step */
    if (n === TOTAL_STEPS) buildSummary();

    /* Scroll to top of configurator */
    $wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* Expose goToStep for inline onclick in review table */
  window.efgGoToStep = goToStep;

  /* Progress node click — allow jumping back to completed steps */
  $$('.ef-cfg-gas-progress__node').forEach(function(node) {
    node.addEventListener('click', function() {
      var s = parseInt(node.getAttribute('data-step'));
      if (s < state.step) goToStep(s);
    });
  });

  /* Back buttons */
  $$('[data-back]').forEach(function(btn) {
    btn.addEventListener('click', function() { goToStep(state.step - 1); });
  });

  /* ================================================================
     STEP 1 — Fuel Type
     ================================================================ */
  (function buildFuel() {
    var fuelPills = $$('#efgFuelType .ef-cfg-gas-pill');
    var fuelTip = document.getElementById('efgFuelTip');

    function syncFuelTip(fuelLabel) {
      if (!fuelTip) return;
      if (fuelLabel === 'Propane') fuelTip.removeAttribute('hidden');
      else fuelTip.setAttribute('hidden', '');
    }

    fuelPills.forEach(function(pill) {
      pill.addEventListener('click', function() {
        fuelPills.forEach(function(p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        var fuelLabel = pill.getAttribute('data-fuel');
        state.fuelType = DATA.fuelTypes.filter(function(f) { return f.label === fuelLabel; })[0] || DATA.fuelTypes[0];
        /* Reset ignition to first available for the new fuel */
        var ignList = DATA.ignitionByFuel[fuelLabel] || [];
        state.ignition = ignList[0] || null;
        syncFuelTip(fuelLabel);
        renderIgnitionCards();
        updateTotal();
      });
    });

    /* Init tip visibility from initial state */
    syncFuelTip(state.fuelType ? state.fuelType.label : 'Natural Gas');

    /* 2026-05-06 — efgNext1 / efgNext2 removed in flat single-page layout.
       Defensive check prevents IIFE crash on missing element. */
    var _next1 = document.getElementById('efgNext1');
    if (_next1) _next1.addEventListener('click', function() { goToStep(2); });
  })();

  /* ================================================================
     STEP 2 — Ignition (image cards, conditional on fuel)
     ================================================================ */
  function renderIgnitionCards() {
    var container = document.getElementById('efgIgnitionCards');
    if (!container) return;
    var fuelLabel = state.fuelType ? state.fuelType.label : 'Natural Gas';
    var options = DATA.ignitionByFuel[fuelLabel] || [];
    var activeName = state.ignition ? state.ignition.name : null;

    container.innerHTML = options.map(function(opt, idx) {
      var isActive = (opt.name === activeName) || (!activeName && idx === 0);
      return '<div class="efg-ignition-card' + (isActive ? ' is-active' : '') + '" data-idx="' + idx + '" role="radio" aria-checked="' + (isActive ? 'true' : 'false') + '" tabindex="0">' +
        '<img class="efg-ignition-card__img" src="' + opt.img + '" alt="' + opt.name + '" loading="lazy" decoding="async">' +
        '<div class="efg-ignition-card__body">' +
          '<div class="efg-ignition-card__name">' + opt.name + '</div>' +
          '<div class="efg-ignition-card__desc">' + opt.desc + '</div>' +
          '<div class="efg-ignition-card__price">' + fmt(opt.surcharge) + '</div>' +
        '</div>' +
      '</div>';
    }).join('');

    $$('.efg-ignition-card', container).forEach(function(card) {
      card.addEventListener('click', function() {
        var idx = parseInt(card.getAttribute('data-idx'));
        $$('.efg-ignition-card', container).forEach(function(c) { c.classList.remove('is-active'); c.setAttribute('aria-checked', 'false'); });
        card.classList.add('is-active');
        card.setAttribute('aria-checked', 'true');
        state.ignition = options[idx];
        updateTotal();
      });
    });
  }

  (function buildIgnition() {
    renderIgnitionCards();
    var _next2 = document.getElementById('efgNext2');
    if (_next2) _next2.addEventListener('click', function() { goToStep(3); });
  })();

  /* "Match My Fireplace" button → open Gas Logs Sizing Tool in popup window (2026-05-06).
     Routes to /pages/gas-logs-tool (templates/page.gas-logs-tool.json + ef-gas-logs-tool section).
     Wider popup (760×900) since the tool has 2-col diagram + measurement layout.
     Falls back to new tab if popups blocked. */
  (function wireAiBtn() {
    var btn = document.getElementById('efgAiBtn');
    if (!btn) return;
    btn.addEventListener('click', function() {
      var url = '/pages/gas-logs-tool';
      var w = Math.min(820, window.screen.availWidth - 40);
      var h = Math.min(900, window.screen.availHeight - 80);
      var l = Math.max(0, (window.screen.availWidth - w) / 2);
      var t = Math.max(0, (window.screen.availHeight - h) / 2);
      var features = 'width=' + w + ',height=' + h + ',left=' + l + ',top=' + t +
                     ',menubar=no,toolbar=no,location=no,status=no,scrollbars=yes,resizable=yes';
      var popup = window.open(url, 'efGasLogsTool', features);
      if (!popup || popup.closed || typeof popup.closed === 'undefined') {
        window.open(url, '_blank', 'noopener');
      } else {
        popup.focus();
      }
    });
  })();

  /* ================================================================
     STEP 4 — Summary
     ================================================================ */
  function buildSummary() {
    var container = document.getElementById('efgReviewTable');
    if (!container) return;

    var rows = [
      { label: 'Fuel Type', value: state.fuelType ? state.fuelType.label : '\u2014', surcharge: state.fuelType ? state.fuelType.surcharge : 0, step: 1 },
      { label: 'Ignition', value: state.ignition ? state.ignition.name : '\u2014', surcharge: state.ignition ? state.ignition.surcharge : 0, step: 2 }
    ];

    var html = '';
    rows.forEach(function(r) {
      var priceHtml = r.surcharge > 0 ? '<span style="color:#8A6A43;font-weight:500;margin-right:8px;">+$' + r.surcharge.toLocaleString() + '</span>' : '';
      html += '<div style="display:flex;align-items:center;padding:12px 16px;border-bottom:1px solid #E8E2D9;font-family:Inter,sans-serif;font-size:13px;">' +
        '<span style="font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:0.08em;color:#8A8579;min-width:120px;">' + r.label + '</span>' +
        '<span style="flex:1;font-weight:500;color:#1E1E1B;">' + r.value + '</span>' +
        priceHtml +
        '<a href="#" onclick="event.preventDefault();efgGoToStep(' + r.step + ');" style="font-size:12px;color:#8A6A43;text-decoration:none;font-weight:500;">Edit \u2192</a>' +
      '</div>';
    });

    container.innerHTML = html;
  }

  /* ================================================================
     ADD TO CART — same pattern as doors/mantel
     ================================================================ */
  document.getElementById('efgSubmit').addEventListener('click', function() {
    var btn = this;
    if (btn.disabled) return;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    /* Build properties from selections */
    var props = {};
    if (state.fuelType) {
      props['Fuel Type'] = state.fuelType.label;
      if (state.fuelType.surcharge > 0) props['_surcharge_fuel'] = '+$' + state.fuelType.surcharge.toLocaleString();
    }
    if (state.ignition) {
      props['Ignition'] = state.ignition.name;
      if (state.ignition.surcharge > 0) props['_surcharge_ignition'] = '+$' + state.ignition.surcharge.toLocaleString();
    }

    var notesEl = document.getElementById('efgNotes');
    if (notesEl && notesEl.value.trim()) props['_Notes'] = notesEl.value.trim();

    /* Configured price for cart display */
    var basePrice = (window.EF_GAS_LOGS_DATA.basePrice / 100);
    var total = basePrice + calcTotal();
    props['_Configured Price'] = '$' + total.toLocaleString('en-US', {minimumFractionDigits:2});
    var configId = Date.now().toString(36);
    props['_config_id'] = configId;

    var variantId = window.EF_GAS_LOGS_DATA.variantId;
    var prodTitle = window.EF_GAS_LOGS_DATA.prodTitle;

    /* Build items array — main product + surcharge variant line items */
    var items = [];

    /* 1) Main product item */
    items.push({
      id: parseInt(variantId),
      quantity: 1,
      properties: props
    });

    /* 2) Surcharge variant items — each gets its own line item */
    if (state.fuelType && state.fuelType.variantId && state.fuelType.surcharge > 0) {
      items.push({
        id: parseInt(state.fuelType.variantId),
        quantity: 1,
        properties: {
          '_parent_product': prodTitle,
          '_option_type': 'Fuel Type',
          '_config_id': configId
        }
      });
    }
    if (state.ignition && state.ignition.variantId && state.ignition.surcharge > 0) {
      items.push({
        id: parseInt(state.ignition.variantId),
        quantity: 1,
        properties: {
          '_parent_product': prodTitle,
          '_option_type': 'Ignition Type',
          '_config_id': configId
        }
      });
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Cart error ' + res.status);
      return res.json();
    })
    .then(function() {
      /* Show success on button */
      btn.textContent = 'Added to Cart \u2713';
      btn.style.background = '#8A6A43';

      setTimeout(function() {
        /* Open cart drawer */
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        var drawer = document.getElementById('cart-drawer');
        if (drawer && typeof drawer.show === 'function') {
          drawer.show();
        } else if (drawer) {
          var cartLink = document.querySelector('[aria-controls="cart-drawer"]');
          if (cartLink) cartLink.click();
          else window.location.href = '/cart';
        } else {
          window.location.href = '/cart';
        }

        /* Reset button after 2s */
        setTimeout(function() {
          btn.disabled = false;
          btn.style.background = '';
          btn.textContent = 'Add to Cart \u2014 $' + total.toLocaleString('en-US', {minimumFractionDigits:2});
        }, 2000);
      }, 800);
    })
    .catch(function(err) {
      console.error('ATC error:', err);
      btn.disabled = false;
      btn.style.background = '';
      btn.textContent = 'Error \u2014 Try Again';
      setTimeout(function() {
        btn.textContent = 'Add to Cart \u2014 $' + total.toLocaleString('en-US', {minimumFractionDigits:2});
      }, 2000);
    });
  });

  /* ── Init ── */
  updateProgress();
  updateTotal();

  /* ================================================================
     EXPRESS CHECKOUT — silent ATC + /checkout redirect (2026-05-06)
     Same pattern as standard PDP (.ef-uni-express). Uses the same
     #efgSubmit click flow but redirects to /checkout instead of opening drawer.
     ================================================================ */
  var expressBtn = document.getElementById('efgExpressCheckout');
  if (expressBtn) {
    expressBtn.addEventListener('click', function() {
      if (expressBtn.disabled) return;
      expressBtn.disabled = true;
      expressBtn.style.opacity = '0.7';
      expressBtn.textContent = 'Loading checkout…';
      /* Build same items array used by main ATC */
      var props = {};
      var configId = 'efg-' + Date.now();
      var items = [];
      var qty = 1;
      var mainItem = {
        id: parseInt(EF_GAS_LOGS_DATA.variantId),
        quantity: qty,
        properties: {}
      };
      if (state.fuelType) {
        mainItem.properties['Fuel Type'] = state.fuelType.label;
      }
      if (state.ignition) {
        mainItem.properties['Ignition'] = state.ignition.name;
      }
      mainItem.properties['_config_id'] = configId;
      items.push(mainItem);
      /* Add fuel surcharge variant if applicable */
      if (state.fuelType && state.fuelType.variantId && state.fuelType.surcharge > 0) {
        items.push({
          id: parseInt(state.fuelType.variantId),
          quantity: qty,
          properties: { '_parent_product': EF_GAS_LOGS_DATA.prodTitle, '_config_id': configId }
        });
      }
      /* Add ignition surcharge variant if applicable */
      if (state.ignition && state.ignition.variantId && state.ignition.surcharge > 0) {
        items.push({
          id: parseInt(state.ignition.variantId),
          quantity: qty,
          properties: { '_parent_product': EF_GAS_LOGS_DATA.prodTitle, '_config_id': configId }
        });
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(r) { if (!r.ok) throw new Error('cart-add-failed'); return r.json(); })
      .then(function() { window.location.href = '/checkout'; })
      .catch(function(err) {
        console.error('[gas-logs] express checkout failed', err);
        expressBtn.disabled = false;
        expressBtn.style.opacity = '';
        expressBtn.textContent = 'Express Checkout';
        alert('Could not start checkout. Please use Add to Cart instead.');
      });
    });
  }

  /* ================================================================
     GALLERY — Thumbnail Rail Carousel
     ================================================================ */
  (function initGallery() {
    var rail = document.getElementById('efgThumbRail');
    if (!rail) return;
    var mainImg = document.getElementById('efgMainImage');
    var counter = document.getElementById('efgCounter');
    var prevBtn = document.getElementById('efgThumbPrev');
    var nextBtn = document.getElementById('efgThumbNext');
    var thumbs = rail.querySelectorAll('.ef-cfg-gas-thumb');
    var total = thumbs.length;

    function activate(idx) {
      thumbs.forEach(function(t) { t.classList.remove('is-active'); });
      thumbs[idx].classList.add('is-active');
      var src = thumbs[idx].getAttribute('data-full');
      if (window.efgCrossfade) window.efgCrossfade(src);
      else mainImg.src = src;
      if (typeof efgCurrentIdx !== 'undefined') efgCurrentIdx = idx;
      if (counter) counter.textContent = (idx + 1) + ' / ' + total;
      /* Scroll thumb into view */
      var thumb = thumbs[idx];
      var railRect = rail.getBoundingClientRect();
      var thumbRect = thumb.getBoundingClientRect();
      if (thumbRect.left < railRect.left || thumbRect.right > railRect.right) {
        thumb.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      }
    }

    thumbs.forEach(function(t, i) {
      t.addEventListener('click', function() { activate(i); });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        rail.scrollBy({ left: -rail.offsetWidth * 0.6, behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        rail.scrollBy({ left: rail.offsetWidth * 0.6, behavior: 'smooth' });
      });
    }
  })();

  /* ================================================================
     GALLERY — Lens Zoom
     ================================================================ */
  (function() {
    var galleryMain = document.querySelector('.ef-cfg-gas-gallery__main');
    var lens = document.getElementById('efgLens');
    if (!galleryMain || !lens) return;
    var zoom = 2.5;
    galleryMain.addEventListener('mousemove', function(e) {
      var mainImg = document.getElementById('efgMainImage');
      if (!mainImg) return;
      var rect = galleryMain.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;
      lens.style.left = (x - 90) + 'px';
      lens.style.top = (y - 90) + 'px';
      lens.style.backgroundImage = 'url(' + mainImg.src + ')';
      lens.style.backgroundSize = (rect.width * zoom) + 'px ' + (rect.height * zoom) + 'px';
      lens.style.backgroundPosition = -(x / rect.width * rect.width * zoom - 90) + 'px ' + -(y / rect.height * rect.height * zoom - 90) + 'px';
    });
    galleryMain.addEventListener('mouseleave', function() { lens.style.display = 'none'; });
    galleryMain.addEventListener('mouseenter', function() { if (window.innerWidth > 1024) lens.style.display = 'block'; });
  })();

})();

/* ── Gallery prev/next navigation ── */
var efgAllMedia = (window.EF_GAS_LOGS_DATA && window.EF_GAS_LOGS_DATA.media) || [];
var efgCurrentIdx = 0;

/* Preload all gallery images so rapid arrow taps hit the browser cache. */
(function efgPreloadGallery() {
  efgAllMedia.forEach(function(src) {
    var pre = new Image();
    pre.decoding = 'async';
    pre.src = src;
  });
})();

/* Crossfade with decode() to wait for paint readiness; token guards against
   rapid-tap race so only the latest swap restores opacity. */
var efgCrossfadeToken = 0;
window.efgCrossfade = function(src) {
  var mainImg = document.getElementById('efgMainImage');
  if (!mainImg || mainImg.src === src) return;
  var token = ++efgCrossfadeToken;
  mainImg.style.opacity = '0.35';
  var finish = function() {
    if (token !== efgCrossfadeToken) return;
    mainImg.style.opacity = '1';
  };
  if (mainImg.decode) {
    mainImg.src = src;
    mainImg.decode().then(finish).catch(finish);
  } else {
    mainImg.onload = finish;
    mainImg.onerror = finish;
    mainImg.src = src;
  }
};

window.efgNavImage = function(dir) {
  efgCurrentIdx = (efgCurrentIdx + dir + efgAllMedia.length) % efgAllMedia.length;
  window.efgCrossfade(efgAllMedia[efgCurrentIdx]);
  // Update counter
  var counter = document.getElementById('efgCounter');
  if (counter) counter.textContent = (efgCurrentIdx + 1) + ' / ' + efgAllMedia.length;
  // Highlight thumbnail
  var thumbs = document.querySelectorAll('.ef-cfg-gas-thumb');
  thumbs.forEach(function(t, i) {
    t.classList.toggle('is-active', i === efgCurrentIdx);
    if (i === efgCurrentIdx) t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  });
};

/* ── Accordion toggle: moved to top of file (see window.efgAccToggle there) ── */
